var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRadioAccessorySelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 52,
    viewBox: "0 0 58 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7775 40.2964C21.923 40.2964 25.2836 37.0491 25.2836 33.0432C25.2836 29.0374 21.923 25.79 17.7775 25.79C13.6321 25.79 10.2715 29.0374 10.2715 33.0432C10.2715 37.0491 13.6321 40.2964 17.7775 40.2964Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0731 14.7401H13.3993L42.0977 3.56712C43.0314 3.2061 43.4964 2.14148 43.1395 1.18737C42.7862 0.233261 41.7444 -0.241951 40.8144 0.122747L2.96321 14.858C2.95239 14.8654 2.94518 14.8728 2.93437 14.8801C1.27973 15.2117 0 16.6373 0 18.424V47.8945C0 49.928 1.61859 51.5783 3.60487 51.5783H54.0731C56.063 51.5783 57.678 49.928 57.678 47.8945V18.424C57.678 16.3942 56.063 14.7401 54.0731 14.7401V14.7401ZM18.0244 44.2107C12.0619 44.2107 7.20975 39.2523 7.20975 33.1592C7.20975 27.0662 12.0619 22.1078 18.0244 22.1078C23.9868 22.1078 28.839 27.0662 28.839 33.1592C28.839 39.2523 23.9868 44.2107 18.0244 44.2107ZM50.4682 44.2107H36.0487V40.5269H50.4682V44.2107ZM50.4682 36.8431H36.0487V33.1592H50.4682V36.8431ZM50.4682 29.4754H36.0487V25.7916H50.4682V29.4754Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 11.1949,
    y1: 28.952,
    x2: 26.4546,
    y2: 32.1462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E66AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 3.54786,
    y1: 11.2426,
    x2: 61.7675,
    y2: 24.4112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CA7D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E66AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioAccessorySelected);
export default __webpack_public_path__ + "static/media/radioAccessory_selected.cd5bee4f82b91abd59459a6282b5e7c5.svg";
export { ForwardRef as ReactComponent };